/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class VastuSelectionControllerService {
    /**
     * @param propertyId
     * @returns any Return value of VastuSelectionController.getVastuSelection
     * @throws ApiError
     */
    public static vastuSelectionControllerGetVastuSelection(
        propertyId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/vastu-selection/{propertyId}',
            path: {
                'propertyId': propertyId,
            },
        });
    }
}
